import React, { useState } from "react";

// ASSETS

import Xsign from "assets/svg/XSign.svg";
import mapIconSelected from "assets/svg/MapIconSelected.svg";
import phoneIconSelected from "assets/svg/PhoneIconSelected.svg";
import manIconSelected from "assets/svg/ManIconSelected.svg";
import DecoDsu from "assets/svg/DecoDSUMeniu.svg";
import searchIcon from "assets/svg/SearchIcon.svg";
import searchIconSelected from "assets/svg/SearchIcon.svg";

// STYLES
import {
  HamburgerMenuComponentContainer,
  CloseButton,
  Xbutton,
  ButtonsBarContainer,
  HeaderComponent,
  CirclePositionMiddle,
  CardBody,
  Button,
  Icon,
  LanguageWrapper,
} from "./HamburgerMenuComponentStyled";

// LIBRARIES
import { useNavigate, useLocation } from "react-router";
import { useTranslation } from "react-i18next";

// MISC
import { UIState, IButtons } from "./HamburgerMenuComponentModel";
import { IconButtonAtomProps } from "components/Atoms/IconButtonAtom/IconButtonAtomModel";
import { COLORS } from "constants/variables";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { appRoutes } from "config/AppRoutesConfig";

// REDUX
import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS

import IconButtonAtom from "components/Atoms/IconButtonAtom/IconButtonAtom";
import AccesibilityModal from "components/Atoms/ButtonsBarAtom/AccesilibilyModal/AccesibilityModal";
import CustomText from "components/Atoms/CustomText/CustomText";
import LanguageModal from "components/Atoms/ButtonsBarAtom/LanguageModal/LanguageModal";

const HamburgerMenuComponent: React.FC<UIState> = (props) => {
  // PROPERTIES
  const { isOpen, onOpen } = props;

  // STATE CONSTANTS

  const [uiState, setUiState] = useState<IButtons>({
    selectedIconIndex: null,
    isModalOpen: false,
  });
  const [isLanguageModalOpen, setIsLanguageModalOpen] =
    useState<boolean>(false);
  const iconsList: IconButtonAtomProps[] = [
    {
      id: 0,
      icon: searchIcon,
      isSelected: uiState.selectedIconIndex === 0,
      iconHovered: searchIconSelected,
      shouldNavigateOn: true,
      isText: false,
      path: appRoutes.search,
    },
    {
      id: 1,
      icon: mapIconSelected,
      isSelected: uiState.selectedIconIndex === 0,
      shouldNavigateOn: true,
      path: appRoutes.map,
    },
    {
      id: 2,
      icon: phoneIconSelected,
      isSelected: uiState.selectedIconIndex === 1,
      shouldNavigateOn: true,
      path: appRoutes.contact,
    },
    {
      id: 3,
      icon: manIconSelected,
      isSelected: uiState.selectedIconIndex === 2,
      shouldNavigateOn: false,
    },
  ];

  // LIBRARY CONSTANTS
  const location = useLocation();
  const isHomePath = location.pathname === "/";
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS
  const handleIconClick = (iconProps: IconButtonAtomProps) => {
    setUiState({
      selectedIconIndex: iconProps.id,
      isModalOpen: iconProps.id === 2,
      shouldNavigateOn: iconProps.shouldNavigateOn,
      path: iconProps.path,
    });
    if (iconProps.shouldNavigateOn) {
      navigate(iconProps.path);
      onOpen();
    }
  };

  const closeAccesibilityModal = () =>
    setUiState((prev) => ({
      ...prev,
      isModalOpen: false,
      selectedIconIndex: null,
    }));

  const handleCloseLanguage = () => {
    setIsLanguageModalOpen(false);
  };
  const handleOpenLanguage = () => {
    setIsLanguageModalOpen(true);
  };

  return (
    <>
      {isOpen && (
        <>
          <HamburgerMenuComponentContainer>
            <HeaderComponent>
              <ButtonsBarContainer>
                {iconsList.map((iconProps, index) => (
                  <IconButtonAtom
                    desktop={false}
                    key={index}
                    {...iconProps}
                    isSelected={
                      iconProps.shouldNavigateOn
                        ? window.location.pathname === iconProps.path
                        : uiState.selectedIconIndex === index
                    }
                    onClick={() => handleIconClick(iconProps)}
                  />
                ))}
              </ButtonsBarContainer>
              {isHomePath && (
                <LanguageWrapper onClick={handleOpenLanguage}>
                  <CustomText
                    text={i18n.language.toUpperCase()}
                    type={TextType.H3}
                    color={COLORS.RaisinBlack}
                  />
                </LanguageWrapper>
              )}
              <CloseButton onClick={onOpen} biggerCursor={biggerCursor}>
                <Xbutton src={Xsign} />
              </CloseButton>
            </HeaderComponent>
            {isHomePath && (
              <LanguageModal
                isOpenProps={isLanguageModalOpen}
                setIsOpenProps={handleCloseLanguage}
                options={[
                  { label: "Romana", value: "ro" },
                  { label: "English", value: "en" },
                ]}
              />
            )}

            <AccesibilityModal
              isOpen={uiState.isModalOpen}
              onClose={closeAccesibilityModal}
            />
            <CardBody>
              <Button
                isSelected={location.pathname === appRoutes.about}
                onClick={() => {
                  navigate(appRoutes.about);
                  onOpen();
                }}
                biggerCursor={biggerCursor}
              >
                <CustomText
                  text={t("components.hamburgerMenu.about")}
                  type={TextType.H2}
                  color={COLORS.Yellow}
                />
              </Button>
              <Button
                isSelected={location.pathname === appRoutes.dsuNumbers}
                onClick={() => {
                  navigate(appRoutes.dsuNumbers);
                  onOpen();
                }}
                biggerCursor={biggerCursor}
              >
                <CustomText
                  text={t("components.hamburgerMenu.dsuNumbers")}
                  type={TextType.H2}
                  color={COLORS.Yellow}
                />
              </Button>
              <Button
                isSelected={location.pathname === appRoutes.news}
                onClick={() => {
                  navigate(appRoutes.news);
                  onOpen();
                }}
                biggerCursor={biggerCursor}
              >
                <CustomText
                  text={t("components.hamburgerMenu.news")}
                  type={TextType.H2}
                  color={COLORS.Yellow}
                />
              </Button>
              <Button
                isSelected={location.pathname === appRoutes.legislation}
                onClick={() => {
                  navigate(appRoutes.legislation);
                  onOpen();
                }}
                biggerCursor={biggerCursor}
              >
                <CustomText
                  text={t("components.hamburgerMenu.legislation")}
                  type={TextType.H2}
                  color={COLORS.Yellow}
                />
              </Button>
              <Button
                isSelected={location.pathname === appRoutes.dialog}
                onClick={() => {
                  navigate(appRoutes.dialog);
                  onOpen();
                }}
                biggerCursor={biggerCursor}
              >
                <CustomText
                  text={t("components.hamburgerMenu.dialog")}
                  type={TextType.H2}
                  color={COLORS.Yellow}
                />
              </Button>
            </CardBody>
            <CirclePositionMiddle>
              <Icon src={DecoDsu} />
            </CirclePositionMiddle>
          </HamburgerMenuComponentContainer>
        </>
      )}
    </>
  );
};

export default HamburgerMenuComponent;
